module.exports = __webpack_public_path__ + "onboarding-targets.494cafd941b0bb82e82fe68775766796.hashedasset.svg";